var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 9,
    viewBox: "0 0 16 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.56702 8.73806L0.159024 1.61925C0.0530732 1.51744 0 1.40025 0 1.26788C0 1.1355 0.0530732 1.01831 0.159024 0.9165L0.953951 0.152812C1.0599 0.0508125 1.18166 0 1.31961 0C1.45756 0 1.57932 0.0508125 1.68527 0.152812L7.93288 6.15637L14.1807 0.152812C14.2866 0.0508125 14.4086 0 14.5461 0C14.6841 0 14.806 0.0508125 14.912 0.152812L15.7065 0.9165C15.8127 1.01831 15.8654 1.1355 15.8654 1.26788C15.8654 1.40025 15.8125 1.51744 15.7065 1.61925L8.29854 8.73788C8.19258 8.83969 8.07063 8.8905 7.93288 8.8905C7.79512 8.8905 7.67317 8.83988 7.56702 8.73806V8.73806Z",
    fill: "#212121"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/ArrowDown.10c1424b52fb3dbe4bf03b63ad062c51.svg";
export { ForwardRef as ReactComponent };